import styles from "./Filters.module.css";
import { useEffect, useState } from "react";
import { Box, Button, Slider, typographyClasses } from "@mui/material";
import ToggleButton from "../../UI/ToggleButton";
import ButtonAdditionalQuestions from "./ButtonAdditionalQuestions";
import TypeFilter from "./TypeFilter";

const customMarks = [
    { value: 0, label: "10" },
    { value: 180, label: "20" },
    { value: 360, label: "35" },
    { value: 540, label: "50" },
    { value: 720, label: "75" },
    { value: 776, label: "100" },
    { value: 832, label: "200" },
    { value: 888, label: "300" },
    { value: 944, label: "500" },
    { value: 1000, label: "1000" },
];

const allServiceGroups = ["FAST NET", "SUPER STREAM", "RUNE"];

export default function Filters({
    serviceTypes,
    setServiceTypes,
    speed,
    setSpeed,
    availableServices,
    setFilteredServices,
    setServiceGroups,
    setInHelp,
    selectedAttributes,
    setSelectedAttributes,
}) {
    const toggleserviceType = (type) => {
        setInHelp((prevValue) => ({ ...prevValue, active: false }));
        setServiceTypes([type]);
    };

    const updateSpeed = (event) => {
        const speed = parseInt(event.target.value);
        const mark = customMarks.find((el) => el.value === speed);
        setSpeed(mark);
    };

    useEffect(() => {
        let temp = [...availableServices];
        temp = temp.filter(
            (el) =>
                el.speed <= speed.label && el.service_type === serviceTypes[0]
        );

        setFilteredServices(temp);

        let tempServiceGroups = [
            ...new Set(temp.map((el) => el.service_group)),
        ];

        tempServiceGroups.sort((a, b) => {
            return allServiceGroups.indexOf(a) - allServiceGroups.indexOf(b);
        });

        setServiceGroups(tempServiceGroups);
    }, [speed, availableServices, serviceTypes]);

    return (
        <div className={styles.filters}>
            <div className={styles.slider}>
                <div className={styles[`slider-label`]}>
                    <div className={styles[`slider-title`]}>
                        Brzina interneta
                    </div>
                    <div className={styles[`slider-speed`]}>
                        {speed ? speed.label : 0} Mbps
                    </div>
                </div>
                <Box width={"100%"} margin={"auto"}>
                    <Slider
                        sx={{
                            color: "primary.main", // Changes the primary color of the slider
                            "& .MuiSlider-thumb": {
                                backgroundColor: "#93C021", // Thumb color
                            },
                            "& .MuiSlider-track": {
                                backgroundColor: "#93C021", // Track color
                                border: "none",
                            },
                            "& .MuiSlider-rail": {
                                backgroundColor: "#93C021", // Rail color
                            },
                        }}
                        value={speed.value}
                        valueLabelDisplay="off"
                        marks={customMarks.map((el) => {
                            return { value: el.value };
                        })}
                        step={null} // this disables automatic steps
                        min={0}
                        max={1000}
                        onChange={updateSpeed}
                    />
                </Box>
                <div className={styles[`slider-description`]}>
                    Odaberi maksimalnu potrebnu brzinu
                </div>
            </div>
            <TypeFilter
                serviceTypes={serviceTypes}
                setServiceTypes={setServiceTypes}
                setInHelp={setInHelp}
            />

            <ButtonAdditionalQuestions
                selectedAttributes={selectedAttributes}
                setInHelp={setInHelp}
                mobileActive={true}
            >
                Niste sigurni? <br /> Kliknite Ovdje!
            </ButtonAdditionalQuestions>
        </div>
    );
}
